import React, { useState, useEffect } from "react";
import { Form } from "antd";
import { gql, useMutation } from "@apollo/client";
import { Spin } from "antd";
import { useSelector } from "react-redux";
import { ADD_BANK_ACCOUNTS } from "../../../graphql/mutations/accounts";

function AddBank(props) {
  const [addAccountState, setAddAccountState] = useState({
    bankName: "",
    bankAccountName: "",
    bankAccountNumber: "",
    bankAddress: "",
    swiftCode: "",
  });
  const [profileId, setProfileId] = useState("");
  const [loader, setLoader] = useState("");

  const userProfile = useSelector((state) => state.strapiRes);

  const getProfileId = async () => {
    const value = await localStorage.getItem("profileId");
    setProfileId(value);
  };

  useEffect(() => {
    getProfileId();
  }, [profileId]);

  const {
    bankName,
    bankAccountName,
    bankAccountNumber,
    bankAddress,
    swiftCode,
  } = addAccountState;
  const [addBankAccount] = useMutation(gql(ADD_BANK_ACCOUNTS));

  const handleAddAccount = () => {
    if (
      bankName &&
      bankAccountName &&
      bankAccountNumber &&
      bankAddress &&
      swiftCode
    ) {
      setLoader(true);
      addBankAccount({
        variables: {
          profileId: profileId || userProfile?.id,
          bankName: bankName,
          accountName: bankAccountName,
          accountNumber: bankAccountNumber,
          address: bankAddress,
          swiftCode: swiftCode,
        },
      })
        .then((res) => {
          setLoader(false);
          setAddAccountState({
            bankName: "",
            bankAccountName: "",
            bankAccountNumber: "",
            bankAddress: "",
            swiftCode: "",
          });
          props.handleCancel()
        })
    }
  };

  return (
    <Spin className="loading" spinning={loader}>
      <div className="accountModal-container">
        <div className="card-body">
          <div className="row m-0 justify-content-between pb-4">
            <h2 className="heading">Add new Bank account</h2>
          </div>
          <div className="content-wrapper mt-4">
            <Form className="form">
              <div className="input-field">
                <label>Bank name</label>
                <input
                  type="text"
                  placeholder="Bank of America"
                  name="bankName"
                  value={bankName}
                  onChange={(event) =>
                    setAddAccountState({
                      ...addAccountState,
                      [event.target.name]: event.target.value,
                    })
                  }
                />
              </div>
              <div className="input-field">
                <label>Bank account name</label>
                <input
                  type="text"
                  placeholder="Tim Smith"
                  name="bankAccountName"
                  value={bankAccountName}
                  onChange={(event) =>
                    setAddAccountState({
                      ...addAccountState,
                      [event.target.name]: event.target.value,
                    })
                  }
                />
              </div>
              <div className="input-field">
                <label>Bank account number</label>
                <input
                  type="text"
                  placeholder="1665 4488 4545 1213"
                  name="bankAccountNumber"
                  value={bankAccountNumber}
                  onChange={(event) =>
                    setAddAccountState({
                      ...addAccountState,
                      [event.target.name]: event.target.value,
                    })
                  }
                />
              </div>
              <div className="input-field">
                <label>Bank address</label>
                <input
                  type="text"
                  placeholder="2972 Westheimer Rd.Santa Ana lllinois85486"
                  name="bankAddress"
                  value={bankAddress}
                  onChange={(event) =>
                    setAddAccountState({
                      ...addAccountState,
                      [event.target.name]: event.target.value,
                    })
                  }
                />
              </div>
              <div className="row m-0">
                <div className="input-field col-4 pl-0">
                  <label>Swift Code</label>
                  <input
                    type="text"
                    placeholder="BOFAUS3N"
                    name="swiftCode"
                    value={swiftCode}
                    onChange={(event) =>
                      setAddAccountState({
                        ...addAccountState,
                        [event.target.name]: event.target.value,
                      })
                    }
                  />
                </div>
              </div>
            </Form>
          </div>
          <div className="row d-flex signup-with mt-4">
            <div className="col-6">
              <button className="cancel" onClick={props.handleCancel}>
                Cancel
              </button>
            </div>
            <div className="col-6">
              <button className="intro" onClick={() => handleAddAccount()}>
                Add Bank
              </button>
            </div>
          </div>
        </div>
      </div>
    </Spin>
  );
}

export default AddBank;
